import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import NoItems from '../../../assets/noitems.png'
import { getBrands } from '../../../redux/communityReducers/BrandSlice'
import { setShowMembershipModal } from '../../../redux/designerReducers/designerReducer'
import { LoadingIndicator2 } from '../../Loading'
import * as style from '../details.module.css'
import { MobileDivider } from '../MobileDivider'
import { MyDecorModal } from './MyDecorModal'
import ProductCard from './ProductCard'

const Title = styled.div`
  padding: 36px 18px 16px;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;

  @media only screen and (max-width: 1034px) {
    padding: 16px;
    background-color: white;
    text-align: center;
  }
`

const FeedContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 18px;
  padding-left: 18px;
  padding-bottom: 18px;

  @media only screen and (min-width: 768px) and (max-width: 1034px) {
    gap: 30px;
    padding: 0 18px;
  }

  @media only screen and (max-width: 768px) {
    justify-content: space-around;
    padding: 0 18px;
  }

  @media (max-width: 600px) {
    gap: 14px;
    padding: 0 22px;
    box-sizing: border-box;
    justify-content: space-between;
    padding-bottom: 30px;
  }
`

const ContentContainer = styled.div`
  height: 720px;
  overflow-y: auto;
  @media only screen and (max-width: 1034px) {
    height: 435px;
  }
`

const Arrow = styled.div`
  visibility: hidden;
  width: 0;
  height: 0;
  @media only screen and (min-width: 768px) and (max-width: 1034px) {
    text-align: center;
    height: 16px;
    visibility: visible;
  }
`

const ProductContainer = ({ title, children, ...props }) => {
  return (
    <>
      <div className={style.currentItemHeader}>
        <MobileDivider />
        <Title id={'currentItem'}>{title}</Title>
      </div>
      <ContentContainer {...props}>{children}</ContentContainer>
    </>
  )
}

export const Product = ({ title, loading, data, markedId, ...props }) => {
  const [showMyDecor, setShowMyDecor] = useState(false)
  const isMember = useSelector(state => state.profile.me?.member)
  const dispatch = useDispatch()

  const handleShowMembershipModal = () => {
    dispatch(setShowMembershipModal(true))
    setShowMyDecor(false)
  }

  useEffect(() => {
    dispatch(getBrands())
  }, [])

  if (loading)
    return (
      <ProductContainer className={style.product_list} title={title}>
        <LoadingIndicator2 loading={loading} />
      </ProductContainer>
    )
  if (data && data.length === 0)
    return (
      <ProductContainer className={style.product_list} title={title} style={{ textAlign: 'center' }}>
        <img src={NoItems} alt={'no-items'} width="70%" /> <p>NO ITEMS YET</p>
      </ProductContainer>
    )

  return (
    <>
      <ProductContainer className={style.product_list} title={title}>
        <FeedContainer>
          {data.map((d, i) => (
            <ProductCard id={d.objectId} key={d.objectId + i} index={i} data={d} marked={d.title !== 'MyDecor' && markedId === d.objectId} handleShowMyDecor={() => setShowMyDecor(true)} {...props} />
          ))}
        </FeedContainer>
      </ProductContainer>
      {showMyDecor && <MyDecorModal isMember={isMember} handleClose={() => setShowMyDecor(false)} handleShowMembershipModal={handleShowMembershipModal} />}
    </>
  )
}

export default Product
